import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class InspectionResultMapping extends CloudObject {

    /**
     * @return {number}
     */
    getInspectionMark() {
        return this.get(InspectionResultMapping.inspectionMarkProp);
    }

    /**
     * @return {number}
     */
    getResult() {
        return this.get(InspectionResultMapping.resultProp);
    }
}

// Hardcoded tags
register('01880b42595b1117e65e', InspectionResultMapping);
InspectionResultMapping.inspectionMarkProp = defineProperty('01880b428e1d82b188a9');
InspectionResultMapping.resultProp = defineProperty('01880b4293c24dd5e880');
